// extracted by mini-css-extract-plugin
module.exports = {"story_menu":"StoryMenu_story_menu__Jwtdi","story_mobilemenu":"StoryMenu_story_mobilemenu__vUoc6"};